import { useTranslation, Trans } from "react-i18next";
const ContactDetails = () => {
    const { t } = useTranslation();

    return (
        <div className="details" id="get-in-touch-section">
            <div className="container">
                <div className="row gy-4">
                    <div className="col-md-6">
                        <div className="contacts ps-md-5">
                            <h2 className="text-color-bright fs-1 mb-md-5">{t('Get in Touch')}</h2>

                            {/* Phone */}
                            <div className="contact mb-3 d-flex align-items-center gap-2">
                                <a href="tel:+9647508702687" aria-label="Phone">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.48 2.53.73 3.88.73a1 1 0 011 1V20a1 1 0 01-1 1C10.07 21 3 13.93 3 5a1 1 0 011-1h3.5a1 1 0 011 1c0 1.35.25 2.67.73 3.88a1 1 0 01-.21 1.11l-2.2 2.2z"/>
                                    </svg>
                                </a>
                                <span>+964 750 843 8497 <br/>
                                +964 750 386 0037</span>
                            </div>

                            {/* Email */}
                            <div className="contact mb-3 d-flex align-items-center gap-2">
                                <a href="mailto:atheer.adai@gmail.com" aria-label="Email">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 2l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
                                    </svg>
                                </a>
                                <span>info@akadgatepharmacy.com</span>
                            </div>

                            {/* Location */}
                            <div className="contact d-flex align-items-start gap-2">
                                <a href="https://goo.gl/maps/grXeQPPuYhXbepDV9" aria-label="Location">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
                                    </svg>
                                </a>
                                <div className="d-flex flex-column align-items-center align-items-sm-start">
                                    <span className="d-inline-block">Br1 - Ankawa - Beside Marhaba Mall</span>
                                    <span className="d-inline-block">Br2 - Ankawa - Mar Elia Complex</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Opening Hours */}
                    <div className="col-md-6">
                        <div className="schedule pe-md-4">
                            <h2 className="text-color-bright fs-1 mb-md-5">{t('Opening Hours')}</h2>
                            <div className="date mb-3">
                                <span className="day me-3">Sunday - Wednesday</span>
                                <span className="time">8 AM - 4 PM</span>
                            </div>
                            <div className="date mb-3">
                                <span className="day me-3">Thursday</span>
                                <span className="time">9 AM - 2 PM</span>
                            </div>
                            <div className="date">
                                <span className="day me-3">Friday</span>
                                <span className="time">{t('Closed')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactDetails;
